export default {
  data() {
    return {
      /**
       * ElScrollbar 상태 데이터
       * @type {Object}
       */
      scrollData: {},
      /**
       * 스크롤 최상단 이동 가능 여부
       * scroll 위치가 0이 아닌 경우 true
       * @type {Boolean}
       */
      enableScollTop: false,
      /**
       * ElScrolbar에 설정할 reference
       * @type {String}
       */
      scrollbarRef: 'scrollbar',
    };
  },
  watch: {
    /**
     * ElScrollbar의 데이터를 관찰하여 스크롤 Y축 위치가 변경된 경우 스크롤 최상단 이동 가능 여부를 체크하여 상태 값으로 설정한다.
     * @type {Object}
     */
    scrollData: {
      deep: true,
      handler(to) {
        this.enableScollTop = to.moveY !== 0;
      },
    },
  },
  methods: {
    /**
     * El-scrollbar의 스크롤 위치 변경 여부를 감지하기 위해 스크롤바 데이터를 상태 값으로 관리한다.
     * @author Ju
     */
    setScrollData() {
      /* eslint-disable no-underscore-dangle */
      if (this.$refs[this.scrollbarRef]) {
        this.scrollData = this.$refs[this.scrollbarRef]._data;
      }
      /* eslint-enable no-underscore-dangle */
    },
    /**
     * Scrollbar를 최상단으로 이동시킨다.
     * @author Ju
     * @return {[type]} [description]
     */
    moveScrollTop() {
      this.$refs[this.scrollbarRef].$refs.wrap.scrollTop = 0;
    },
  },
};



// WEBPACK FOOTER //
// ./src/mixins/scrollbar.js